
const ADD_INCOME_OR_DEDUCTION_SOURCE_MODAL = 'ADD_INCOME_OR_DEDUCTION_SOURCE_MODAL';
const ADD_EMPLOYER_COVERAGE_DETAIL_MODAL = 'ADD_EMPLOYER_COVERAGE_DETAIL_MODAL';
const ADD_HRA_DETAIL_MODAL = 'ADD_HRA_DETAIL_MODAL';
const DECEASED_MEMBER_MODAL = 'DECEASED_MEMBER_MODAL';
const EXPECTED_INCOME_MODAL = 'EXPECTED_INCOME_MODAL';
const FALLBACK_UI_MODAL = 'FALLBACK_UI_MODAL';
const INDEPENDENT_TAX_FILERS_MODAL = 'INDEPENDENT_TAX_FILERS_MODAL';
const INFORM_MEDICARE_ELIGIBLE_MODAL = 'INFORM_MEDICARE_ELIGIBLE_MODAL';
const INFORM_LAWFULLY_PRESENCE_REQUIRED_FOR_COVERAGE_MODAL = 'INFORM_LAWFULLY_PRESENCE_REQUIRED_FOR_COVERAGE_MODAL';
const INFORM_TO_ADD_INCOME_SOURCE_MODAL = 'INFORM_TO_ADD_INCOME_SOURCE_MODAL';
const LEAVE_PAGE_MODAL = 'LEAVE_PAGE_MODAL';
const LOCATE_ASSISTANCE_MODAL = 'LOCATE_ASSISTANCE_MODAL';
const MANDATORY_SEEKING_FOR_COVERAGE_MODAL = 'MANDATORY_SEEKING_FOR_COVERAGE_MODAL';
const MULTI_TAX_HOUSEHOLD_MODAL = 'MULTI_TAX_HOUSEHOLD_MODAL';
const OTHER_ADDRESS_MODAL = 'OTHER_ADDRESS_MODAL';
const REMOVE_MEMBER_MODAL = 'REMOVE_MEMBER_MODAL';
const REMOVE_INCOME_OR_DEDUCTION_SOURCE_MODAL = 'REMOVE_INCOME_OR_DEDUCTION_SOURCE_MODAL';
const SSAP_EXIT_MODAL = 'SSAP_EXIT_MODAL';
const UNDO_MEMBER_REMOVAL_MODAL = 'UNDO_MEMBER_REMOVAL_MODAL';
const VALIDATE_ADDRESS_MODAL = 'VALIDATE_ADDRESS_MODAL';

const EXTRA_MODAL = 'EXTRA_MODAL'; // TODO: For testing only, not for production

export const ssapModalTypes = {
    ADD_INCOME_OR_DEDUCTION_SOURCE_MODAL,
    ADD_EMPLOYER_COVERAGE_DETAIL_MODAL,
    ADD_HRA_DETAIL_MODAL,
    DECEASED_MEMBER_MODAL,
    EXPECTED_INCOME_MODAL,
    FALLBACK_UI_MODAL,
    INDEPENDENT_TAX_FILERS_MODAL,
    INFORM_TO_ADD_INCOME_SOURCE_MODAL,
    INFORM_MEDICARE_ELIGIBLE_MODAL,
    INFORM_LAWFULLY_PRESENCE_REQUIRED_FOR_COVERAGE_MODAL,
    LEAVE_PAGE_MODAL,
    LOCATE_ASSISTANCE_MODAL,
    MANDATORY_SEEKING_FOR_COVERAGE_MODAL,
    MULTI_TAX_HOUSEHOLD_MODAL,
    OTHER_ADDRESS_MODAL,
    REMOVE_MEMBER_MODAL,
    REMOVE_INCOME_OR_DEDUCTION_SOURCE_MODAL,
    SSAP_EXIT_MODAL,
    UNDO_MEMBER_REMOVAL_MODAL,
    VALIDATE_ADDRESS_MODAL,
    EXTRA_MODAL
};
